@if (showModal) {
<app-dialog-title>{{ "add-to-batch" | transloco }}</app-dialog-title>
<mat-dialog-content class="content filter-item">
  @if (errorMessage) {
  <p class="error-message">{{ errorMessage }}</p>
  } @if (bulkActionState !== 'COMPLETED') {
  <div>
    <p>
      Adding {{ selectedTaxReturnIds.length }} {{ taxReturnAlias
      }}{{ selectedTaxReturnIds.length === 1 ? "" : "s" }} to the batch
    </p>
    <div class="content filter-item">
      <label>{{ "add-to-existing-batch" | transloco }}</label>
      <br />
      <div class="ui search selection dropdown" #batchDropdown>
        <div class="text"></div>
        <div class="menu"></div>
        <i class="chevron down icon"></i>
      </div>
    </div>
  </div>
  } @if (bulkActionState === 'COMPLETED') {
  <div>
    <p>
      {{ taxReturnAlias
      }}{{ selectedTaxReturnIds.length === 1 ? "" : "s" }} added to the batch
    </p>
  </div>
  }
</mat-dialog-content>
@if (bulkActionState !== 'COMPLETED') {
<mat-dialog-actions align="end">
  <a class="go-back cancel" (click)="onClose()">{{ "cancel" | transloco }}</a>
  <button
    class="ui primary button"
    (click)="createBatch()"
    [disabled]="submitButtonDisabled"
    [ngClass]="{ loading: bulkActionState === 'LOADING' }"
  >
    {{ "add-to-batch" | transloco }}
  </button>
</mat-dialog-actions>
} @if (bulkActionState === 'COMPLETED') {
<mat-dialog-actions align="end">
  <button class="ui primary button" (click)="onClose(true)">
    {{ "ok" | transloco }}
  </button>
</mat-dialog-actions>
} }
